import React from "react";
import { PageHero, Section, ACTIVITIES } from "./_shared";
import { Sparkles } from "lucide-react";

export default function Activities() {
  return (
    <div data-testid="mitsol-activities">
      <PageHero
        eyebrow="Beyond the Workshop"
        title="Student Activities & Celebrations"
        sub="Our curriculum extends beyond trades — regular guest lectures, community-service drives and cultural observances build well-rounded, socially aware technicians."
      />
      <Section>
        <div className="grid md:grid-cols-2 gap-5">
          {ACTIVITIES.map((a, i) => (
            <div key={i} className="bg-white border-l-4 border-[#F97316] p-6 shadow-sm hover:shadow-md transition-shadow" data-testid={`mitsol-activity-${i}`}>
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 shrink-0 flex items-center justify-center bg-[#F97316]/10 text-[#F97316] font-serif font-black text-lg">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div>
                  <div className="font-serif text-lg text-[#0F2A47] leading-tight">{a.title}</div>
                  <div className="text-[11px] text-slate-500 italic mt-0.5">{a.mr}</div>
                  <p className="mt-2.5 text-sm text-slate-700 leading-relaxed">{a.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-10 bg-[#FEF9F0] border-l-4 border-[#F97316] p-6 flex items-start gap-3">
          <Sparkles className="text-[#F97316] mt-1 shrink-0" size={20} />
          <div>
            <div className="font-semibold text-[#0F2A47]">More snapshots on the Gallery</div>
            <div className="text-sm text-slate-700 mt-1">Photographs from every activity are curated on the institute Gallery page — accessible from the main navigation.</div>
          </div>
        </div>
      </Section>
    </div>
  );
}
